import { UI, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

export interface EmptyListProps {
  title: string;
  description: string;
}

export const EmptyList: React.FC<EmptyListProps> = ({ description, title }) => {
  return (
    <VStack alignItems="center" paddingY={Spacing['stack.xxxl']}>
      <VStack alignItems="center" space={Spacing['stack.quarck']} maxW="330px">
        <UI.Illustration name="NotEmptyIllustration" testId="empty-illustration" />
        <UI.Text color="neutral.black" variant="semibold">
          {title}
        </UI.Text>
        <UI.Text color="neutral.black" textAlign="center">
          {description}
        </UI.Text>
      </VStack>
    </VStack>
  );
};
